import * as React from "react";
const SvgRefresh = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M34 34v5h.582m0 0a8.001 8.001 0 0 1 15.356 2m-15.356-2H39m11 11v-5h-.581m0 0a8.003 8.003 0 0 1-15.357-2m15.357 2H45"
    />
  </svg>
);
export default SvgRefresh;
